(function () {
  if (window.__mainProductInteractionsInitialized) return;
  window.__mainProductInteractionsInitialized = true;

  function openDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    var overlay = document.getElementById(drawerId.replace('VoucherDrawer-', 'VoucherOverlay-'));
    if (!drawer) return;

    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    var overlay = document.getElementById(drawerId.replace('VoucherDrawer-', 'VoucherOverlay-'));
    if (!drawer) return;

    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function openPopup(popupId) {
    var popup = document.getElementById(popupId);
    if (!popup) return;

    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(popupId) {
    var popup = document.getElementById(popupId);
    if (!popup) return;

    popup.classList.remove('is-open');
    var anyOpen = document.querySelector('.voucher-popup.is-open') || document.querySelector('.voucher-drawer.is-open');
    if (!anyOpen) document.body.style.overflow = '';
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.make-it-a-set__select');
    if (!select) return;

    var productId = select.dataset.productId;
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var price = selectedOption.dataset.price;
    var compareAtPrice = selectedOption.dataset.compareAtPrice;
    var row = select.closest('.make-it-a-set__item') || document;
    var priceEl = row.querySelector('.make-it-a-set__price[data-product-id="' + productId + '"]');
    var btn = row.querySelector('.make-it-a-set__add-btn[data-product-id="' + productId + '"]');

    if (priceEl) {
      var html = '';
      if (compareAtPrice && parseInt(compareAtPrice, 10) > parseInt(price, 10)) {
        html += '<s>' + Shopify.formatMoney(compareAtPrice, theme.moneyFormat) + '</s> ';
      }
      html += '<span>' + Shopify.formatMoney(price, theme.moneyFormat) + '</span>';
      priceEl.innerHTML = html;
    }

    if (btn) {
      btn.disabled = selectedOption.disabled;
    }
  });

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.make-it-a-set__add-btn');
    if (addBtn) {
      var miniCart = document.querySelector('mini-cart');
      var productId = addBtn.dataset.productId;
      var variantId = addBtn.dataset.variantId;

      if (!variantId) {
        var select = document.getElementById('MakeItASet-Variant-' + productId);
        if (select) variantId = select.value;
      }
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.classList.add('loading');

      var sections = miniCart ? miniCart.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var body = JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_add_url, Object.assign(fetchConfig('javascript'), { body: body }))
        .then(function (res) { return res.json(); })
        .then(function (parsedState) {
          if (parsedState.status) {
            console.error('Make It A Set add error:', parsedState.description);
          } else if (miniCart) {
            miniCart.renderContents(parsedState);
          }
        })
        .catch(function (err) { console.error(err); })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('loading');
        });
      return;
    }

    var drawerBtn = e.target.closest('[data-voucher-drawer]');
    if (drawerBtn) {
      openDrawer(drawerBtn.dataset.voucherDrawer);
      return;
    }

    var popupBtn = e.target.closest('[data-voucher-popup]');
    if (popupBtn) {
      openPopup(popupBtn.dataset.voucherPopup);
      return;
    }

    var closeDrawerBtn = e.target.closest('[data-close-drawer]');
    if (closeDrawerBtn) {
      closeDrawer(closeDrawerBtn.dataset.closeDrawer);
      return;
    }

    var closePopupBtn = e.target.closest('[data-close-popup]');
    if (closePopupBtn) {
      closePopup(closePopupBtn.dataset.closePopup);
      return;
    }

    var overlay = e.target.closest('.voucher-drawer-overlay');
    if (overlay) {
      var id = overlay.id.replace('VoucherOverlay-', 'VoucherDrawer-');
      closeDrawer(id);
      return;
    }

    var copyBtn = e.target.closest('[data-copy-code]');
    if (copyBtn) {
      var code = copyBtn.dataset.copyCode;
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;

      navigator.clipboard.writeText(code).then(function () {
        var orig = copyBtn.textContent;
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = orig; }, 2000);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var openDrawerEl = document.querySelector('.voucher-drawer.is-open');
    if (openDrawerEl) {
      closeDrawer(openDrawerEl.id);
      return;
    }

    var openPopupEl = document.querySelector('.voucher-popup.is-open');
    if (openPopupEl) closePopup(openPopupEl.id);
  });

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event.data.variant;
    var sectionId = event.data.sectionId;
    if (!variant || !sectionId) return;

    var els = document.querySelectorAll('[data-cashback-section="' + sectionId + '"]');
    els.forEach(function (el) {
      var percent = parseFloat(el.dataset.cashbackPercent) || 5;
      var cashback = Math.round(variant.price * percent / 100);
      var formatted = theme.Currency.formatMoney(cashback, theme.shopSettings.moneyFormat);
      el.innerHTML = el.dataset.cashbackTemplate.replace('[amount]', formatted);
    });
  });
})();
